import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../app/app.environment';

/**
 * Service to handle PDF upload to Azure Blob Storage via backend API
 */
@Injectable({
  providedIn: 'root',
})
export class PdfUploadService {
  private apiUrl = environment.apiURL;

  constructor(private http: HttpClient) {}

  uploadInvoicePdf(
    pdfBlob: Blob,
    invoiceUuid: string,
    fileName?: string,
  ): Observable<any> {
    const formData = new FormData();
    const pdfFileName = fileName || `invoice_${invoiceUuid}_${Date.now()}.pdf`;
    formData.append('file', pdfBlob, pdfFileName);

    const uploadUrl = `${this.apiUrl}v1/sale/uploadinvoicetemplate/${invoiceUuid}`;

    console.log('[PDF Upload Service] URL:', uploadUrl);
    console.log('[PDF Upload Service] File name:', pdfFileName);
    console.log('[PDF Upload Service] Blob size:', pdfBlob.size, 'bytes');

    return this.http.post(uploadUrl, formData);
  }

  uploadSuspensePdf(
    pdfBlob: Blob,
    suspenseUuid: string,
    fileName?: string,
  ): Observable<any> {
    const formData = new FormData();
    const pdfFileName =
      fileName || `suspense_${suspenseUuid}_${Date.now()}.pdf`;
    formData.append('file', pdfBlob, pdfFileName);

    const uploadUrl = `${this.apiUrl}v1/sale/uploadsuspensetemplate/${suspenseUuid}`;

    console.log('[PDF Upload Service] Uploading Suspense PDF to Azure');
    console.log('[PDF Upload Service] URL:', uploadUrl);
    console.log('[PDF Upload Service] File name:', pdfFileName);

    return this.http.post(uploadUrl, formData);
  }

  uploadCreditNotePdf(
    pdfBlob: Blob,
    invoiceUuid: string,
    fileName?: string,
  ): Observable<any> {
    const formData = new FormData();
    const pdfFileName =
      fileName || `credit_note_${invoiceUuid}_${Date.now()}.pdf`;
    formData.append('file', pdfBlob, pdfFileName);

    const uploadUrl = `${this.apiUrl}v1/sale/uploadreturntemplate/${invoiceUuid}`;

    console.log('[PDF Upload Service] Uploading Credit Note PDF to Azure');
    console.log('[PDF Upload Service] URL:', uploadUrl);
    console.log('[PDF Upload Service] File name:', pdfFileName);

    return this.http.post(uploadUrl, formData);
  }
}
